import { TFunction } from 'i18next'

// eslint-disable-next-line @typescript-eslint/no-explicit-any, no-restricted-globals
export const isValidDate = (input: any) => input instanceof Date && isFinite(+input)

export function convertDateToDateString(date: Date): string {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const getISODay: (date: Date) => string = (dt) => `0${dt.getDate()}`.slice(-2)
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const getISOMonth: (date: Date) => string = (dt) => `0${dt.getMonth() + 1}`.slice(-2)

  return `${date.getFullYear()}-${getISOMonth(date)}-${getISODay(date)}`
}

export function convertDateToRoundedDecimalTime(date: Date): number {
  if (!isValidDate(date)) {
    return 0
  }

  const hrs = Math.floor(Math.abs(date.getHours()))
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  return hrs + dateMinutesToDecimal(date)
}

export function convertDateToTimeStampString(date: Date): string {
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  return `${convertDateToDateString(date)}T${convertDateToTimeString(date)}`
}

export function convertDateToTimeString(date: Date): string {
  const ISOHours = `0${date.getHours()}`.slice(-2)
  const ISOMinutes = `0${date.getMinutes()}`.slice(-2)
  return `${ISOHours}:${ISOMinutes}:00`
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export function convertDecimalToISOTime(minutes: number): string {
  const sign = minutes < 0 ? '-' : ''
  const hrs = Math.floor(Math.abs(minutes))
  const mins = Math.floor((Math.abs(minutes) * 60) % 60)
  return `${sign + (hrs < 10 ? '0' : '') + hrs}:${mins < 10 ? '0' : ''}${mins}`
}

export const dateMinutesToDecimal = (date: Date, roundUp: boolean = false, interval: number = 15): number => {
  if (!isValidDate(date)) {
    return 0
  }

  let decimalMinutes = Math.ceil(date.getMinutes() / interval) * interval
  if (decimalMinutes >= interval) {
    decimalMinutes /= interval
  }
  const factor = 1 / (60 / interval)

  return decimalMinutes * factor + (roundUp ? factor : 0)
}

export function timeToText(date: string): string {
  return date.substr(0, 5)
}

function dayOfWeekAsString(dayIndex: number) {
  return ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][dayIndex]
}

function monthAsString(index: number) {
  return [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ][index]
}

export function dateToText(date: string, t: TFunction): string {
  const dateObj = new Date(date)

  if (isValidDate(dateObj)) {
    return `${t(dayOfWeekAsString(dateObj.getDay()))}, ${dateObj.getDate()} ${t(monthAsString(dateObj.getMonth()))}`
  }

  return ''
}
